import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const RestoreIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 2 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <polyline points="1 4 1 10 7 10" stroke={color} strokeWidth={strokeWidth} fill="none" />
      <path d="M3.5 15a9 9 0 1 0 .5-9.4L1 10" stroke={color} strokeWidth={strokeWidth} fill="none" />
    </BaseIcon>
  ),
);

RestoreIcon.displayName = 'RestoreIcon';
